import styled from 'styled-components';
import { Input } from 'antd';
import {
  InputFocusStyles,
  InputFontStyles,
  InputPadding,
  InputSize,
  InputStyles,
} from '../../theme';

export const StyledInput = styled(Input)`
  ${InputStyles};
  ${InputFocusStyles};
  ${InputFontStyles};
  ${InputPadding};
  ${InputSize};
`;
